import React from "react";
import { unwrapResult } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";

import LoginComponent from "./loginComponent";

import { login } from "../../redux/state/accountSlice";

const ChooseRecivingMethod = () => {

    const { search } = useLocation();
    const dispatch = useDispatch();
    const history = useHistory();

    const token = window.localStorage.getItem('refresh-token');

    if (!!token) {
        history.push(`/payment-method${search}`)
    }

    const loginHandler = ({ email, password }) => {
        dispatch(login({ email, password }))
            .then(unwrapResult)
            .then(() => history.push(`/payment-method${search}`))
            .catch(({ title }) => console.error(title))
    }

    return <LoginComponent onLogin={loginHandler} createAccount={false} />
}

export default ChooseRecivingMethod;